// extracted by mini-css-extract-plugin
export var dateLabel = "_46-0";
export var dateLabelError = "_46-1";
export var fullWidth = "_46-2";
export var smaller = "_46-3";